<template>
  <abk-surveys-list surveys-type="inactive"/>
</template>

<script>
import AbkSurveysList from '../../../components/surveys/AbkSurveysList'
export default {
  name: 'InactiveSurveysTab',
  components: { AbkSurveysList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.surveys.list_tabs.inactive_surveys_tab.title'),
        subtitle: this.$t('views.surveys.list_tabs.inactive_surveys_tab.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped>

</style>
